<template>
  <CreateEventButton
    :default-date="defaultDate"
    :sheet="sheet"
    :flags-resolved="flagsResolved"
  >
    <template #trigger>
      <Fob>
        <i class="fa-regular fa-plus w-5 h-5" />
      </Fob>
    </template>
  </CreateEventButton>
</template>

<script setup lang="ts">
import Fob from "@/components/Seranova/Fobs/Fob.vue";
import CreateEventButton from "./CreateEventButton.vue";

// `sheet` and `flagsResolved` are passed straight through. The defaults leave
// the classic board's FOB (Scheduler/SchedulePage.vue) exactly as it is: a modal,
// mounted without waiting on a placement decision it never makes.
withDefaults(
  defineProps<{
    defaultDate?: Date | string;
    sheet?: boolean;
    flagsResolved?: boolean;
  }>(),
  { defaultDate: undefined, sheet: false, flagsResolved: true }
);
</script>

<style scoped></style>
